<input type="text"
       class="form-control"
       [cpUseRootViewContainer]=true
       [(colorPicker)]="color"
       cpPosition="bottom-left"
       (colorPickerChange)="textColorChanged($event)"
       [(ngModel)]="color"
>

